import Component from './direct_message_history_dialog.vue'
export default Component
